import { ToggleSwitch } from './ToggleSwitch'
import { withToggleSwitch } from './withToggleSwitch'

const ConnectedToggleSwitch = withToggleSwitch(ToggleSwitch)

export { ConnectedToggleSwitch as ToggleSwitch }
